// frontend/src/components/Header.js - Updated
import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import authService from '../services/auth/authService';
import creditService from '../services/credit/creditService';
import CreditPurchaseModal from './CreditPurchaseModal';
import SpinningCreditCounter from './SpinningCreditCounter';
import '../styles/global.css';
import './Header.css';
import './SpinningCreditCounter.css';

const Header = () => {
  const { user, logout, creditBalance, updateCreditBalance } = useContext(AuthContext);
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [showCreditAlert, setShowCreditAlert] = useState(false);
  const navigate = useNavigate();

  // Modify this useEffect to check on both mount and when credit balance changes
  useEffect(() => {
    // Only check restriction status when user exists and either on mount or credit balance changes
    if (!user) return;
    
    const checkRestrictionStatus = async () => {
      try {
        const isRestricted = await creditService.checkRestrictionStatus();
        
        // Only show the full credit alert if there's a server-side restriction
        setShowCreditAlert(isRestricted);
      } catch (error) {
        console.error("Error checking translation restriction:", error);
        // Don't change alert status on error
      }
    };
    
    checkRestrictionStatus();
  }, [user, creditBalance]); // Add creditBalance as dependency

  const signOut = async () => {
    try {
      await authService.signOut();
      logout(); // Clear user in AuthContext
      navigate('/login');
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  // Get CSS class based on credit balance
  const getCreditClass = () => {
    // Adjust thresholds for K format if needed, but keeping the logic
    if (creditBalance <= 0) return 'critical-credits';
    if (creditBalance < 5000) return 'low-credits'; // Threshold for 'low' warning
    return '';
  };

  return (
    <>
      <header className="header">
        <div className="header-container">
          <div className="header-logo" onClick={() => navigate('/')}>
            <span className="header-emoji">😛</span>
            <span className="header-title">Face with Tongue</span>
          </div>

          {user && (
            <div className="header-user">
              {/* Replace old credit display with the new component */}
              <SpinningCreditCounter
                value={creditBalance}
                className={getCreditClass()}
              />

              <button
                onClick={() => setShowPurchaseModal(true)}
                className="btn btn-success btn-sm" // Keep Add Credits button small
                style={{ height: '32px', padding: '0 0.75rem' }} // Match height of counter
              >
                Add Credits
              </button>

              <div className="badge badge-primary user-email">
                {user.email}
              </div>
              <button
                onClick={signOut}
                className="btn btn-outline btn-sm" // Keep Logout button small
                 style={{ height: '32px', padding: '0 0.75rem' }} // Match height of counter
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </header>

      {/* Credit Low Alert - Adjust threshold message if needed */}
      {showCreditAlert && !showPurchaseModal && (
        <div className={`credit-alert ${creditBalance <= 0 ? 'zero-credits' : ''}`}>
          <div className="credit-alert-content">
            <p>
              {creditBalance <= 0
                ? "You've run out of translation credits!"
                : "Your account is restricted due to insufficient credits."}
            </p>
            <button
              onClick={() => setShowPurchaseModal(true)}
              className="btn btn-success btn-sm"
            >
              Purchase Credits
            </button>
          </div>
        </div>
      )}

      {/* Credit Purchase Modal */}
      <CreditPurchaseModal
        isOpen={showPurchaseModal}
        onClose={() => {
          setShowPurchaseModal(false);
          // Refresh credit balance after closing the modal
          updateCreditBalance();
        }}
      />
    </>
  );
};

export default Header;